<template>
	<div>
		<router-view></router-view>
	</div>
</template>
<script>

export default {
	name: 'page-report-evaluation',
};
</script>
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/modules/evaluation-360/pages/page-report-evaluation.vue